import { render } from "./dashboard-std.vue?vue&type=template&id=35a9eec9&ts=true"
import script from "./dashboard-std.vue?vue&type=script&lang=ts"
export * from "./dashboard-std.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__